import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import {
  getAllCountryNames,
  getCountryCode,
} from '../../../../../corelogic/domain/utils/country.utils';

interface CountrySelectorProps {
  value: string;
  onChange: (code: string) => void;
  sx?: any;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  value,
  onChange,
  sx = {},
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const countryName = event.target.value;
    const countryCode = getCountryCode(countryName) || '';
    onChange(countryCode);
  };

  const countryNames = getAllCountryNames();
  const selectedCountryName =
    countryNames.find((name) => getCountryCode(name) === value) || '';

  return (
    <FormControl
      fullWidth
      sx={{
        '& .MuiInputBase-root': {
          color: 'white',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
        '& .MuiFormLabel-root': {
          color: 'rgba(255, 255, 255, 0.7)',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.23)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.5)',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#8B0000',
          },
        },
        ...sx,
      }}
    >
      <InputLabel>Nationality</InputLabel>
      <Select
        value={selectedCountryName}
        label="Nationality"
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#1e1e1e',
              color: 'white',
              maxHeight: '300px',
            },
          },
        }}
        renderValue={(selected) => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {value && (
              <ReactCountryFlag
                countryCode={value}
                svg
                style={{ width: '24px', height: '16px' }}
              />
            )}
            {selected}
          </div>
        )}
      >
        {countryNames.map((name) => {
          const code = getCountryCode(name) || '';
          return (
            <MenuItem key={code} value={name}>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <ReactCountryFlag
                  countryCode={code}
                  svg
                  style={{ width: '24px', height: '16px' }}
                />
                {name}
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
